module.exports = __webpack_public_path__ + "2.jpg?480fe440dc6b962a63b6ab017d145380";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar/2.jpg
// module id = 550
// module chunks = 27